<template>
  <div class="d-flex w-100">
    <span v-if="facilityType" class="planned-list-type mr-2">
      <v-tooltip bottom :max-width="500">
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <v-icon color="lime" size="18">
              mdi-information
            </v-icon>
          </div>
        </template>
        {{
          $t("message.posts.planning.facilitiesSendTooltip", [
            facilityLocationType
          ])
        }} </v-tooltip
      ><span class="ml-1">{{ facilityType }}:</span>
    </span>
    <v-tooltip :disabled="!fullNames" bottom :max-width="500">
      <template v-slot:activator="{ on }">
        <div v-on="on" class="planned-list-type__label">
          {{ label }}
        </div></template
      >
      {{ fullNames }}
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "PostListPlannedSelectedFacilities",
  props: {
    fullNames: {
      type: [String, null]
    },
    label: {
      type: String,
      required: true
    },
    facilityType: {
      type: String
    },
    facilityLocationType: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.planned-list-type {
  display: flex;
  align-items: center;
  font-weight: 400;

  &__label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    margin-right: $spacing * 5;
    flex-grow: 0;
  }
}
</style>
